export default "__VITE_ASSET__e0f0fa86__"